export default "__VITE_ASSET__Dse$VQig__"